export const DISCOVER_MORE_COVERAGE_URL =
  'https://www.hotjar.com/capture-all-sessions-with-Hotjar/';

export const PRICING_PAGE_URL = 'https://www.hotjar.com/pricing/';

export const SESSIONS_WE_CAPTURE = '/articles/115011624047';

export enum MODAL {
  name = 'Post Trial Modal',
  version = 'post-trial-modal',
  editAskProduct = 'Edit Ask product',
  editObserveProduct = 'Edit Observe product',
  selectDropdown = 'Product select dropdown',
  downgradeToBasic = 'Downgrade to basic trigger',
  downgradeToBasicConfirm = 'Downgrade to basic confirm',
  checkoutButton = 'Checkout button',
}
